// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"583aa5eb","411":"93732845","500":"a16ea419"}[chunkId] + ".chunk.js";
};